<template>
    <v-container  class="mt-5" justify-center
                    style="text-align:center;position:relative;height:100%;margin:auto auto;display:flex;align-items: center;justify-content: center;">
      <img :src="require('@/assets/notFound.svg')" width="450" height="450"/>
      </v-container>
</template>

